import * as actionTypes from './actionTypes';
import { keyBy } from 'lodash';

// get student psychology request
export function getMetrics(payload) {

  return { type: actionTypes.GET_METRICS, payload };
}
export function getMetricsSuccess(payload) {
  return { type: actionTypes.GET_METRICS_SUCCESS, payload: payload, };
}


